import React, { useEffect, useState } from "react";

import Dialog from "../../../../../components/Dialog";
import ActivitiesManagementDetails from "./ActivitiesManagementDetails/ActivitiesManagementDetails";
import ActivitiesManagementSummary from "./ActivitiesManagementSummary/ActivitiesManagementSummary";
import ActivitiesManagementForms from "./ActivitiesManagementForms";

import DialogStyles from "../../../../../styles/components/DialogStyles";
import ButtonStyles from "../../../../../styles/components/ButtonStyles";
import { ActivitiesManagementProvider } from "../../../../../context/ActivitiesManagementContext";
import ActivitiesManagementModalHeader from "./ActivitiesManagementModalHeader";
import {
    IActivitiesManagementModal,
    IContent,
} from "../../../interface/IActivitiesManagementModal";
import { useModal } from "../../../../../context/ModalContext";
import GlobalModal from "../../../../../components/GlobalModal";
import { useWorkflow } from "../../../../../context/WorkflowContext";

const { StyledContainerButton } = DialogStyles;
const { DefaultButtonLink } = ButtonStyles;

const SUMMARY = "SUMMARY";
const FORMS = "FORMS";
const DETAILS = "DETAILS";
const AGUARDANDO_APROVACAO = "AGUARDANDO_APROVACAO";

const ActivitiesManagementModal: React.FC<IActivitiesManagementModal> = ({
    open,
    workflow,
    initialContent = null,
    onClose,
}) => {
    const [content, setContent] = useState<IContent>(null);
    const [modalTitle, setModalTitle] = useState<string>("");

    const { openModal, isOpen } = useModal();
    const { workflowFilter, filterWorkflows } = useWorkflow();
    const modal = document.querySelector(".activities-modal");

    const handleInitialContent = () => {
        if (initialContent) return setContent(initialContent);
        return workflowFilter.status === AGUARDANDO_APROVACAO &&
            workflow?.pendenciaCheckIn
            ? setContent("FORMS")
            : setContent("SUMMARY");
    };

    const handleCloseModal = () => {
        openModal();

        if (modal) {
            modal.classList.remove("show");
            modal.classList.add("hide");
        }
    };

    const closeSuccessModal = () => {
        filterWorkflows(workflowFilter);
        onClose();
    };

    const dialogSize = () => {
        if (content === "FORMS") return "modal-xxl";

        return "modal-90w";
    };

    const showSummary = content === SUMMARY && (
        <ActivitiesManagementSummary
            workflow={workflow}
            handleChangeContent={(value: IContent) => setContent(value)}
            onClose={handleCloseModal}
            readOnly={workflow?.statusAprovacao !== AGUARDANDO_APROVACAO}
        />
    );

    const showForms = content === FORMS && (
        <ActivitiesManagementForms
            workflow={workflow}
            handleChangeContent={(value: IContent) => setContent(value)}
            onClose={handleCloseModal}
        />
    );

    const showDetails = content === DETAILS && (
        <ActivitiesManagementDetails
            workflow={workflow}
            changeModalTitle={setModalTitle}
        />
    );

    const handleValidateCloseModal = () => {
        if (content === "DETAILS") {
            setContent("SUMMARY");
            setModalTitle("");
        } else {
            onClose();
        }
    };

    const getCloseModalLabel = () => {
        if (content === "DETAILS") return "Voltar para Ver Extrato";

        if (workflow?.statusAprovacao === AGUARDANDO_APROVACAO)
            return "Cancelar";

        return "Fechar";
    };

    useEffect(() => {
        handleInitialContent();
    }, []);

    return (
        <>
            <Dialog
                openModal={open}
                onHide={handleValidateCloseModal}
                size="lg"
                style={{
                    width: "100%",
                    height: "1000px !important",
                }}
                dialogClassName={dialogSize()}
                className="activities-modal"
            >
                <ActivitiesManagementProvider>
                    <ActivitiesManagementModalHeader
                        modalTitle={modalTitle}
                        workflow={workflow}
                    />
                    {showSummary}
                    {showForms}
                    {showDetails}
                    <StyledContainerButton>
                        <DefaultButtonLink
                            onClick={() => handleValidateCloseModal()}
                        >
                            {getCloseModalLabel()}
                        </DefaultButtonLink>
                    </StyledContainerButton>
                </ActivitiesManagementProvider>
            </Dialog>
            {isOpen && (
                <GlobalModal
                    type="success"
                    successMessage="Processo concluído com sucesso!"
                    onClose={closeSuccessModal}
                />
            )}
        </>
    );
};

export default ActivitiesManagementModal;
